import { CardContent, Grid, ListItem, ListItemText, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Fragment } from 'react';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import { PmiCard } from 'shell/components/shared/card';
import PmiTitle from 'shell/components/shared/title';
import {
  CancelMarriageAuthorizations,
  CohabitationMutationAuthorizations,
  MarriageMenuAuthorization,
  WidowhoodMenuAuthorization,
  RegistrationCitizenshipAuthorizations,
  RegistrationBewareAuthorizations,
  UpdateParenthoodAuthorizations,
  RegistrationCivilUnionAuthorization,
  CancelCivilUnionAuthorization,
  RegistrationAnomalyAuthorizations,
} from 'shell/authorizations/mutation';
import { CertificationAuthorizations } from 'shell/authorizations/front-office';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonMutationCrumbs } from 'mutation/constants/breadcrumb';

const HomePage = (): React.ReactElement => {
  const actions = useActionAuthorization({
    certificazione: CertificationAuthorizations,
    vedovanza: WidowhoodMenuAuthorization,
    registrazioneMatrimonio: MarriageMenuAuthorization,
    annullamentoMatrimonio: CancelMarriageAuthorizations,
    registrazioneCittadinanza: RegistrationCitizenshipAuthorizations,
    mutazioneConvivenza: CohabitationMutationAuthorizations,
    registrazioneDiffida: RegistrationBewareAuthorizations,
    aggiornamentoParentela: UpdateParenthoodAuthorizations,
    registrazioneUnioneCivile: RegistrationCivilUnionAuthorization,
    scioglimentoUnioneCivile: CancelCivilUnionAuthorization,
    registrazioneAnomalie: RegistrationAnomalyAuthorizations,
  });

  return (
    <Fragment>
      <Breadcrumbs items={CommonMutationCrumbs} />
      <PmiTitle title="Mutazioni" paddingBottom={1} />
      <div className="pmi-mb-4">
        <Typography component="div" fontSize=".9rem" color="primary">
          {"Seleziona l'area su cui iniziare ad operare"}
        </Typography>
      </div>
      <Grid container spacing={2}>
        {actions.registrazioneMatrimonio ? (
          <Grid item xs={12} md={4}>
            <Link to="/mutazioni/persona/matrimonio/residenti" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Registrazione Matrimonio" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.registrazioneMatrimonio ? (
          <Grid item xs={12} md={4}>
            <Link to="/mutazioni/persona/matrimonio/non-residenti" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Registrazione Matrimonio Non Residenti" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.annullamentoMatrimonio ? (
          <Grid item xs={12} md={4}>
            <Link to="/mutazioni/persona/matrimonio-annullamento" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Cessazione Matrimonio" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.registrazioneUnioneCivile ? (
          <Grid item xs={12} md={4}>
            <Link to="/mutazioni/persona/unione-civile/residenti" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Registrazione Unione civile" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.registrazioneUnioneCivile ? (
          <Grid item xs={12} md={4}>
            <Link to="/mutazioni/persona/unione-civile/non-residenti" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Registrazione Unione civile Non Residenti" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.scioglimentoUnioneCivile ? (
          <Grid item xs={12} md={4}>
            <Link to="/mutazioni/cerca-persona/unione-civile" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Annullamento Unione Civile" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.vedovanza ? (
          <Grid item xs={12} md={4}>
            <Link to="/mutazioni/persona/vedovanza" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Registrazione Vedovanza" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.mutazioneConvivenza ? (
          <Grid item xs={12} md={4}>
            <Link to="/mutazioni/persona/convivenza" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Registrazione Convivenza di Fatto" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.registrazioneCittadinanza ? (
          <Grid item xs={12} md={4}>
            <Link to="/mutazioni/persona/cittadinanza" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Registrazione Cittadinanza" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.registrazioneDiffida ? (
          <Grid item xs={12} md={4}>
            <Link to="/mutazioni/diffida/registrazione" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Gestione Diffida" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.registrazioneAnomalie ? (
          <Grid item xs={12} md={4}>
            <Link to="/mutazioni/anomalia/registrazione" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Gestione Anomalie" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.aggiornamentoParentela ? (
          <Grid item xs={12} md={4}>
            <Link to="/mutazioni/parentela/aggiornamento" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Aggiornamento Parentela" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {/* {actions.iscrizioneAireCitizenship ? ( */}
        <Grid item xs={12} md={4}>
          <Link to="/mutazioni/persona/risoluzione-convivenza-di-fatto" className="pmi-anchor">
            <PmiCard>
              <CardContent>
                <ListItem>
                  <ListItemText primary="Risoluzione convivenza di Fatto" />
                </ListItem>
              </CardContent>
            </PmiCard>
          </Link>
        </Grid>
        {/* ) : undefined} */}
        {/* {actions.iscrizioneAireCitizenship ? ( */}
        {/* <Grid item xs={12} md={4}>
          <Link to="/mutazioni/notifiche-da-stato-civile" className="pmi-anchor">
            <PmiCard>
              <CardContent>
                <ListItem>
                  <ListItemText primary="Registrazione S.C. - ANAGRAFE" />
                </ListItem>
              </CardContent>
            </PmiCard>
          </Link>
        </Grid> */}
        {/* ) : undefined} */}
        <Grid item xs={12} md={4}>
          <Link to="/mutazioni/notifiche/ansc" className="pmi-anchor">
            <PmiCard>
              <CardContent>
                <ListItem>
                  <ListItemText primary="Aggiornamento anagrafe da ANSC" />
                </ListItem>
              </CardContent>
            </PmiCard>
          </Link>
        </Grid>
      </Grid>
    </Fragment>
  );
};

HomePage.displayName = 'home page component';

export default HomePage;
